/**
 * 统一维护storage存储的键值常量
 */

// Project详情页
export const PROJECT_DETAIL_STORAGE_KEY = {
  GPOP_CACHE_PROJECT_DETAIL_TAB_STORAGE_KEY: 'GPOP_CACHE_PROJECT_DETAIL_TAB',
  GPOP_CACHE_PROJECT_DETAIL_TAB_MODULE_STORAGE_KEY: 'GPOP_CACHE_PROJECT_DETAIL_TAB_MODULE_KEY',
  GPOP_CACHE_MILESTONE_ID_STORAGE_KEY: 'GPOP_CACHE_MILESTONE_ID',
  GPOP_CACHE_UPDATE_ID_STORAGE_KEY: 'GPOP_CACHE_UPDATE_ID',
};

// dps周报
export const DPS_REPORT_STORAGE_KEY = {
  // 周报列表数据（周报预览页获取周报列表数据，点击新增时，把这个数据存sessionStorage，跳到新增周报页后会用到，用来禁用有周报的周日期）
  DPS_REPORT_REPORTS_SUMMARY_STORAGE_KEY: 'GPOP__DPS_WEEKLY_REPORT__REPORTS',
  // 临时存储周报的ID，用于跳转到周报预览页后 默认选中该周报（新增、编辑）
  DPS_REPORT_REPORT_ID: 'GPOP__DPS_WEEKLY_REPORT__REPORT_ID',
  // 临时存储周报日期标题，用于周报编辑功能
  DPS_REPORT_REPORT_TITLE: 'GPOP__DPS_WEEKLY_REPORT__REPORT_DATE_TITLE',
  // // 临时存储周报 置顶模块
  DPS_REPORT_SCROLL_TOP_MODULE: 'GPOP__DPS_WEEKLY_REPORT__SCROLL_TOP_MODULE',
  // 临时存储周报数据，用于周报编辑功能
  DPS_REPORT_REPORT_DETAILS: 'GPOP__DPS_WEEKLY_REPORT__REPORT_DETAILS',
};
